var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { $ } from '../../simpli';
import { Collection } from './Collection';
import { Helper } from '../../main';
var EnumCollection = /** @class */ (function (_super) {
    __extends(EnumCollection, _super);
    function EnumCollection(enumType, i18nPath) {
        var _this = _super.call(this) || this;
        _this.items = Helper.listObject(enumType, i18nPath);
        return _this;
    }
    EnumCollection.prototype.allWithPlaceholder = function (placeholder) {
        if (placeholder === void 0) { placeholder = null; }
        return Helper.allWithPlaceholder(this.items, placeholder);
    };
    EnumCollection.prototype.getResource = function (id) {
        return Helper.getResource(this.items, id);
    };
    EnumCollection.prototype.getManyResource = function (ids) {
        return Helper.getManyResource(this.items, ids);
    };
    EnumCollection.prototype.addResource = function (id, tag, index) {
        Helper.addResource(this.items, Helper.buildResource(id, tag), index);
    };
    EnumCollection.prototype.removeResource = function (id) {
        Helper.removeResource(this.items, id);
    };
    EnumCollection.prototype.prependResource = function (id, tag) {
        Helper.prependResource(this.items, Helper.buildResource(id, tag));
        return this;
    };
    EnumCollection.prototype.prependNullResource = function (tag, useI18n) {
        if (useI18n === void 0) { useI18n = true; }
        return this.prependResource(0, useI18n ? $.t(tag) : tag);
    };
    EnumCollection.prototype.appendResource = function (id, tag) {
        Helper.appendResource(this.items, Helper.buildResource(id, tag));
        return this;
    };
    return EnumCollection;
}(Collection));
export { EnumCollection };
//# sourceMappingURL=EnumCollection.js.map